// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__JerTl","rootSmall":"AddTileButton_rootSmall__3zwLg"};